export default __webpack_public_path__ + "static/media/logo.c7581d2e.png";